import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Box, Button, Typography } from '@mui/material';
import { PATH_ROOT } from 'constants/api';
import { useTranslation } from 'react-i18next';
import OtpInput from 'react-otp-input';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as GmailIcon } from '../../../assets/img/Gmail_Logo.svg';
import { ReactComponent as OutlookIcon } from '../../../assets/img/Outlook.svg';

export default function OTPRegister({otp, setOtp, onSubmit, timerValue, emailAccount, resendOtp, title=''}) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleKeyDown = (e) => {
        // e.preventDefault();
        if(e?.key === "Enter" && otp?.length === 6){
            onSubmit();
        }
    }
    
    return (
        <>
            <Typography fontSize={28} mb={1.25} textAlign={'center'} fontWeight={600}>{title ? title : t('auth.verifyEmail.header')}</Typography>
            <div className="body-verify-email">
                <Typography mb={2.5} textAlign={'center'} display={'flex'} justifyContent={'center'}>{t('auth.verifyEmail.title')} <Typography fontWeight={700} ml={0.5}>{emailAccount}</Typography></Typography>
                <div className="content-verify-email">
                    <div className="otp-verify-email">
                        <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderSeparator={<span className="separator-otp-number"></span>}
                            renderInput={(props) => <input {...props} className="input-otp-field" onKeyDown={handleKeyDown}/>}
                            inputType={'number'}
                            shouldAutoFocus={true}
                        />
                        <div className="countdown-verify-email">
                            <AccessTimeIcon sx={{ color: '#44494D', fontSize: '16px' }} />
                            <Typography sx={{paddingLeft: '5px'}}>{timerValue === "00:00" ? t('auth.verifyEmail.timeCountDown') : timerValue}</Typography>
                        </div>
                    </div>
                    <Button
                        size="large"
                        type={'submit'}
                        variant="contained"
                        sx={{ mb: 1, mt: 1.5 }}
                        fullWidth
                        onClick={onSubmit}
                        disabled={otp?.length < 6}
                    >
                        {t('auth.verifyEmail.verify')}
                    </Button>
                </div>
            </div>
            <div className="footer-verify-email">
                <Typography textAlign={'center'} mb={1}>{t('auth.verifyEmail.receiveEmail')}</Typography>
                <Typography display={'flex'} justifyContent={'center'} mb={3} >
                    {t('auth.verifyEmail.checkEmail')}
                    <Typography ml={0.5} fontWeight={700} sx={{ cursor: 'pointer', color: theme => theme.palette.primary.main, ":hover": { textDecoration: 'underline' } }} tabIndex={0} onClick={resendOtp} onKeyDown={e => {if(e.key === "Enter")resendOtp()}}>{t('auth.verifyEmail.try')}.</Typography>
                </Typography>
                <Box className="content-verify-email">
                    <Typography>{t('popup.otp.has-account')}</Typography>
                    <Typography color={theme => theme.palette.primary.main } sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {navigate(`${PATH_ROOT}/auth/login`)}} onKeyDown={e => {if(e.key === "Enter"){navigate(`${PATH_ROOT}/auth/login`)}}} tabIndex={0} >{t('popup.otp.register')}</Typography>
                </Box>
                <div className="content-verify-email">
                    <Button
                        className="redirect-link-button"
                        variant="outlined"
                        startIcon={<GmailIcon style={{ width: '24px' }} />}
                        onClick={() => window.open('https://mail.google.com/mail', '_blank')}
                    >
                        {t('popup.otp.gmail')}
                    </Button>
                    <Button
                        className="redirect-link-button"
                        variant="outlined"
                        startIcon={<OutlookIcon style={{ width: '24px' }} />}
                        onClick={() => window.open('https://outlook.live.com/mail', '_blank')}
                    >
                        {t('popup.otp.outlook')}
                    </Button>
                </div>
            </div>
        </>
    );
}
